/**
 * Query to find marketplace_seller_feature records by feature_pointer
 */
const sellerFeaturesByFeatureQuery = `
query SellerFeaturesByFeature($where: Marketplace_seller_featureWhereInput) {
  marketplace_seller_features(first: 1000, where: $where) {
    edges {
      node {
        objectId
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default sellerFeaturesByFeatureQuery;
